import { render } from "./PremiseRow.vue?vue&type=template&id=0a8b99d9&scoped=true"
import script from "./PremiseRow.vue?vue&type=script&lang=js"
export * from "./PremiseRow.vue?vue&type=script&lang=js"

import "./PremiseRow.vue?vue&type=style&index=0&id=0a8b99d9&scoped=true&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8b99d9"]])

export default __exports__